"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui";
import { useNavigateHome } from "@/hooks/use-navigate-home";
interface InsufficientPermissionsProps {
  requiredPermissions?: string[];
  requiredRoles?: string[];
}
export default function InsufficientPermissions(t0) {
  const $ = _c(15);
  const {
    requiredPermissions,
    requiredRoles
  } = t0;
  const goHome = useNavigateHome();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h1 className="text-h1 text-foreground">Insufficient Permissions</h1>;
    t2 = <p className="mt-2 text-foreground-secondary">You don't have the required permissions to access this page.</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== requiredPermissions) {
    t3 = requiredPermissions && requiredPermissions.length > 0 && <div className="mt-4 text-body text-muted-foreground"><p className="font-medium">Required permissions:</p><ul className="mt-1 list-inside list-disc">{requiredPermissions.map(_temp)}</ul></div>;
    $[2] = requiredPermissions;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== requiredRoles) {
    t4 = requiredRoles && requiredRoles.length > 0 && <div className="mt-4 text-body text-muted-foreground"><p className="font-medium">Required roles:</p><ul className="mt-1 list-inside list-disc">{requiredRoles.map(_temp2)}</ul></div>;
    $[4] = requiredRoles;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="mt-4 text-body text-muted-foreground">Please contact your administrator to request access.</p>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t4) {
    t6 = <div className="text-center">{t1}{t2}{t3}{t4}{t5}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== goHome) {
    t7 = <Button onClick={goHome} variant="secondary">Go to Home</Button>;
    $[10] = goHome;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <div className="flex h-full flex-col items-center justify-center gap-4">{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
function _temp2(role) {
  return <li key={role} className="text-foreground-secondary">{role}</li>;
}
function _temp(permission) {
  return <li key={permission} className="text-foreground-secondary">{permission}</li>;
}